import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  ActiveModeCommands,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsStringValueProperty,
  OperatingProgramCommands,
  OperatingProgramProperties,
  ProgramCommands,
  ProgramProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { HeatingPanelService, HEATING_PROGRAMS } from '../heating-panel.service';

@Component({
  selector: 'app-program-toggle-panel',
  templateUrl: './program-toggle-panel.component.html',
  styleUrls: ['./program-toggle-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgramTogglePanelComponent implements OnInit, OnDestroy {
  readonly featurePropertyKey = FeaturePropertyKey;

  @Input() circuitId: string;

  ngUnsubscribe$: Subject<void> = new Subject<void>();
  ecoFeature$: Observable<Feature<OperatingProgramProperties, OperatingProgramCommands>>;
  comfortFeature$: Observable<Feature<ProgramProperties, ProgramCommands>>;
  isComfortToggleDisabled = true;
  isEcoToggleDisabled = true;
  operatingModesActive$: Observable<Feature<IsStringValueProperty, ActiveModeCommands>>;

  constructor(
    public heatingPanelService: HeatingPanelService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.ecoFeature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.ECO)
    );

    this.comfortFeature$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitOperatingProgram(this.circuitId, HEATING_PROGRAMS.COMFORT)
    );

    this.operatingModesActive$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitActiveMode(this.circuitId)
    );
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  public onHeatingProgramChange(feature: string, checked: boolean): void {
    this.heatingPanelService.onProgramChange(feature, checked);
  }
}
